import { useDispatch, useSelector } from 'react-redux';

import { isNative } from '@whelk/const/src/env';
import { RootState } from '@whelk/store';
import {
  ImagePreviewParams,
  clearImgMask,
  setImgMaskUrl,
  setImgMaskVisible,
} from '@whelk/store/slices/fileSlice';
import { isMiniProgram } from '@whelk/utils';
import { nativeBridge } from '@whelk/utils/src/bridge/callNativeBridge';

/**
 * 图片预览
 * 包含 对话框图片预览，用户消息卡片预览，机器人卡片消息预览
 * native  使用bridge调用原生方法
 * h5 & web 使用组件实现
 * 小程序 使用小程序原生方法
 */
const useImagePreview = () => {
  const dispatch = useDispatch();
  const { imgMaskUrl, imgMaskUrlList, imgMaskVisible, eventParams } = useSelector(
    (state: RootState) => state.file,
  );

  const nativePreviewImg = ({
    url,
    urlList,
    isByText,
    eventParams,
    position,
  }: ImagePreviewParams) => {
    if (isByText) {
      nativeBridge.callNative({
        methodName: 'launchTextImagePreview',
        params: {
          position: position,
          images: urlList,
          eventParams: eventParams,
        },
      });
    } else {
      nativeBridge.callNative({
        methodName: 'launchImagePreivew',
        params: {
          imageUrl: url,
        },
      });
    }
  };
  const webPreviewImg = (params: ImagePreviewParams) => {
    dispatch(setImgMaskUrl(params));
    dispatch(setImgMaskVisible(true));
  };

  const miniProgramPreviewImg = ({ url, urlList }: ImagePreviewParams) => {
    // 预览图片
    if (!(window as any).wx) return;
    (window as any).wx?.previewImage?.({
      current: url,
      urls: urlList ? urlList?.map((item) => item.medium) : [url],
    });
  };

  const closeImagePreview = () => {
    dispatch(setImgMaskVisible(false));
    dispatch(clearImgMask());
  };

  const openImagePreview = (params: ImagePreviewParams) => {
    if (isNative) {
      nativePreviewImg(params);
    } else if (isMiniProgram) {
      // 小程序
      miniProgramPreviewImg(params);
    } else {
      webPreviewImg(params);
    }
  };
  return {
    closeImagePreview,
    openImagePreview,
    imgMaskUrl,
    imgMaskUrlList,
    imgMaskVisible,
    eventParams,
  };
};

export default useImagePreview;
